import {
  emptyId,
  EntityDataType,
  IDataGridProps,
  IFlow,
  IProperty,
  prepareWorksForWorkGrid,
  TWorks,
  useHeaderHeightForScrollableContent,
  WorkGrid,
} from '@diana/core';
import { Box } from '@mui/material';
import { GridApi, GridSortModel } from '@mui/x-data-grid-premium';
import { forwardRef } from 'react';

export type EntitiesTableProps = {
  flow: IFlow;
  entities: TWorks;
  storageKey: string;
  isLoading: boolean;
  disableLastVisited?: boolean;
  supportedProperties: IProperty[];
  peoplePage: boolean;
  appliedFilters: string[];
  isTableExpandedViewMode: boolean;
  fetchNextPage: () => void;
  onSortModelChange: (model: GridSortModel) => void;
  showSidePeek: boolean;
  aggregateColumnOperation?: IDataGridProps['aggregateColumnOperation'];
};

export const ThingsTable = forwardRef<GridApi, EntitiesTableProps>((props, ref) => {
  const {
    flow,
    entities,
    storageKey,
    isLoading,
    supportedProperties,
    disableLastVisited = false,
    peoplePage,
    isTableExpandedViewMode,
    appliedFilters,
    fetchNextPage,
    onSortModelChange,
    showSidePeek,
    aggregateColumnOperation,
  } = props;
  const columns = supportedProperties;
  const headerHeight = useHeaderHeightForScrollableContent();
  const height = `calc(100vh - ${headerHeight}px)`;
  const excludeCtxMenuItems = peoplePage ? ['showVersion', 'delete'] : [];

  const filteredEntities = [...entities].filter((entity: any) => entity.activeStepId !== emptyId);
  const preparedEntities = prepareWorksForWorkGrid({
    works: filteredEntities,
    properties: supportedProperties,
  });

  return (
    <Box sx={{ height, width: '100%' }}>
      <WorkGrid
        filters={appliedFilters}
        ref={ref}
        isManageColumnsPinned
        disableConfigSave={peoplePage}
        rows={preparedEntities}
        columns={columns.map((e) => ({ ...e, sortable: true }))}
        storageKey={storageKey}
        excludeCtxMenuItems={excludeCtxMenuItems}
        disableLastVisited={disableLastVisited}
        showSidePeek={showSidePeek}
        dataType={peoplePage ? EntityDataType.User : EntityDataType.Thing}
        aggregateColumnOperation={aggregateColumnOperation}
        gridProps={{
          height,
          autoHeight: false,
          sortingMode: 'server',
          onSortModelChange,
          loading: isLoading,
          ...(flow.featureFlags?.isExpandedFeatureEnabled &&
            isTableExpandedViewMode && { idKey: 'rowId' }),
          onRowsScrollEnd: () => {
            fetchNextPage();
          },
        }}
      />
    </Box>
  );
});
